import Sprite from "./sprite.svg?react";

export const IconsSprite = () => <Sprite />;
